(function () {
  const initPopularProductsSliders = () => {
    document.querySelectorAll('.swiper-popular-products').forEach((slider) => {
      if (slider.swiper) return;

      const section = slider.closest('.popular-products-section');
      const previousButton = section.querySelector(
        '.popular-products__arrow--prev'
      );
      const nextButton = section.querySelector(
        '.popular-products__arrow--next'
      );

      new Swiper(slider, {
        slidesPerView: Number(slider.dataset.slidesMobile),
        spaceBetween: 16,
        watchOverflow: true,

        navigation: {
          prevEl: previousButton,
          nextEl: nextButton
        },

        breakpoints: {
          765: {
            slidesPerView: Number(slider.dataset.slidesDesktop),
            spaceBetween: 24
          }
        }
      });
    });
  };

  initPopularProductsSliders();

  document.addEventListener(
    'shopify:section:load',
    initPopularProductsSliders
  );
})();